import { useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";

const CONTACT_PUBLIC_PHONE_FORMATTED = "(832) 862-5679";
const CONTACT_GOOGLE_ADS_PHONE_FORMATTED = "(855) 709-0435";

export const useContactPhone = () => {
  const [phoneFormatted, setPhoneFormatted] = useState(CONTACT_PUBLIC_PHONE_FORMATTED);
  const searchParams = useSearchParams();

  useEffect(() => {
    if (searchParams) {
      const isCustomerFromGoogleAds = searchParams.get("utm_source") === "adwords";
      const phone = isCustomerFromGoogleAds
        ? CONTACT_GOOGLE_ADS_PHONE_FORMATTED
        : CONTACT_PUBLIC_PHONE_FORMATTED;
      setPhoneFormatted(phone);
    }
  }, [searchParams]);

  return {
    phoneFormatted,
    phoneForHTML: phoneFormatted.replace(/\D/g, ""),
  };
};
